import React, { useEffect, useState } from 'react';
import { Tevent } from '../../../type/event';
import { getEventActive } from '../../../service/eventService';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { MINIO } from '../../../data/data';
import { FiMapPin } from 'react-icons/fi';
import { MonthAsByDate } from '../../../utls/date';
import { Link } from 'react-router-dom';

const CarouselEvent = () => {
    const [eventList, setEventList] = useState<Tevent[]>([]);

    const getDataCarousel = async () => {
        const response = await getEventActive();
        if (!response?.error) {
            setEventList(response?.data)
        }

    }

    useEffect(() => {
        getDataCarousel()
    }, [])

    return (
        <>
            <Swiper
                modules={[Autoplay]}
                spaceBetween={20}
                slidesPerView={2}
                autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                className='pb-4'
            >
                {eventList.map((item: Tevent, index: number) => {
                    const date = new Date(item.startDate);
                    const day = date.getDate();
                    return (
                        <SwiperSlide key={index}>
                            <div className='relative rounded-[0.5rem] max-w-[cal(460/2)] max-h-[180px]  overflow-clip bg-white shadow-lg p-4'>
                                <div className='bg-[#171766] absolute px-2 py-1 left-2 top-2 text-white text-center rounded-md'>
                                    <span className='block p-0 m-0 text-[11px]'>{day}</span>
                                    <span className='block p-0 m-0 text-[11px]'>{MonthAsByDate(item.startDate)}</span>
                                </div>
                                <Link to={`/admin/events/${item.slug}`}>
                                    <img src={`${MINIO}/${item.thumbnail}`} />
                                </Link>
                            </div>
                        </SwiperSlide>
                    )
                })}
            </Swiper>
        </>
    );
};

export default CarouselEvent;